import { Aggregations } from '../../../models/Aggregations';

export const filterAggregations = (data: Aggregations, visibleFilterGroups: string[]) =>
    Object.entries(data).reduce<Aggregations>((filtered, [category, value]) => {
        if (visibleFilterGroups.includes(category)) {
            filtered[category] = value;
        }
        return filtered;
    }, {});
